<template>
  <div>
    <h1 v-html="modelValue.Content.StepFive.LabelSectionTitle" />
    <section>
      <article class="flow-group">
        <div class="control">
          <h3>
            <div class="row collapse">
              <strong
                class="columns"
                v-html="modelValue.Content.StepFive.LabelAndTooltipPaymentIntervalTitle"
              />
              <div class="columns">
                <div
                  v-for="(item, index) in paymentFrequensyList"
                  :key="index"
                  class="radio-stacked"
                >
                  <Field
                    :id="'PaymentFrequence' + index"
                    v-model="studyInsuranceSubmitTemplate.PaymentFrequence"
                    :rules="'required'"
                    type="radio"
                    name="PaymentFrequence"
                    :value="item.label"
                    :label="modelValue.Content.StepFive.LabelAndTooltipPaymentIntervalTitle"
                  />
                  <label :for="'PaymentFrequence' + index" v-html="item.label" />
                </div>
              </div>
            </div>
          </h3>
          <ValidationError
            name="PaymentFrequence"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
          />
          <span v-html="modelValue.Content.StepFive.LabelPaymentIntervalDisclaimer" />
        </div>
        <hr />
        <div class="control">
          <p v-html="modelValue.Content.StepFive.LabelPaymentServiceRequirementInformation" />
          <h3>
            <strong
              v-html="modelValue.Content.StepFive.LabelPaymentInformationRegistrationNumber"
            />
          </h3>
          <Field
            v-model="studyInsuranceSubmitTemplate.RegistrationNumber"
            :rules="'required|numeric'"
            type="text"
            name="registrationNumber"
            :label="modelValue.Content.StepFive.LabelPaymentInformationRegistrationNumber"
          />
          <ValidationError
            name="registrationNumber"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
          />

          <h3>
            <strong v-html="modelValue.Content.StepFive.LabelPaymentInformationAccountNumber" />
          </h3>
          <Field
            v-model="studyInsuranceSubmitTemplate.AccountNumber"
            :rules="'required|numeric'"
            type="text"
            name="accountNumber"
            :label="modelValue.Content.StepFive.LabelPaymentInformationAccountNumber"
          />
          <ValidationError
            name="accountNumber"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
          />
        </div>
        <hr />
        <div class="control push-down">
          <h-3-and-tooltip
            :h3="modelValue.Content.StepFive.LabelCpr"
            :tooltip="modelValue.Content.StepFive.TooltipCpr"
          />
          <cpr-number-field
            v-model="studyInsuranceSubmitTemplate.Cpr"
            label="CPR-nummer"
            :required="true"
          />
        </div>
        <div class="control">
          <fieldset class="checkbox-inline">
            <Field
              id="HasGivenCprConsentYes"
              v-model="studyInsuranceSubmitTemplate.HasGivenCprConsent"
              :rules="'required'"
              name="HasGivenCprConsentYes"
              :value="true"
              :unchecked-value="false"
              type="checkbox"
              :label="
                modelValue.Content.StepFive.LabelAndTooltipConsentsTitle +
                ':' +
                modelValue.Content.StepFive.LabelConsentsCprCheckboxYes
              "
              @update:modelValue="cprConsentSelect"
            />
            <label
              for="HasGivenCprConsentYes"
              class="large"
              v-html="modelValue.Content.StepFive.LabelConsentsCprCheckboxYes"
            /><br />

            <Field
              id="HasGivenCprConsentNo"
              v-model="noToCPRConsent"
              name="HasGivenCprConsentNo"
              type="checkbox"
              :value="true"
              :unchecked-value="false"
              :label="
                modelValue.Content.StepFive.LabelAndTooltipConsentsTitle +
                ':' +
                modelValue.Content.StepFive.LabelConsentsCprCheckboxNo
              "
              @update:modelValue="cprConsentSelect"
            />
            <label
              for="HasGivenCprConsentNo"
              class="large"
              v-html="modelValue.Content.StepFive.LabelConsentsCprCheckboxNo"
            />
          </fieldset>
          <ValidationError
            name="HasGivenCprConsentYes"
            :overrides="{ required: decodeHtml(modelValue.Content.StepFive.ValidationCpr) }"
          />
          <p v-html="modelValue.Content.StepFive.LabelConsentsCprConsent" />
          <p>
            <a
              :href="modelValue.Content.StepFive.LinkConsentsCprConsentPersonalDataPolicy.Url"
              target="_blank"
              v-html="modelValue.Content.StepFive.LinkConsentsCprConsentPersonalDataPolicy.Text"
            />
          </p>
        </div>
        <div
          v-if="
            studyInsuranceSubmitTemplate.IsStudyExtra &&
            !studyInsuranceSubmitTemplate.ConsentToContactMemberOrganizationIsNotRequired
          "
          class="control"
        >
          <fieldset class="checkbox-inline">
            <Field
              id="HasGivenConsentToContactMemberOrganization"
              v-model="studyInsuranceSubmitTemplate.HasGivenConsentToContactMemberOrganization"
              :rules="'required'"
              name="HasGivenConsentToContactMemberOrganization"
              type="checkbox"
              :value="true"
              :unchecked-value="false"
            />
            <label
              for="HasGivenConsentToContactMemberOrganization"
              class="large"
              v-html="modelValue.Content.StepFive.LabelConsentsConfirmOrganizationCheckbox"
            />
          </fieldset>
          <ValidationError
            name="HasGivenConsentToContactMemberOrganization"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
          />
          <p v-html="modelValue.Content.StepFive.LabelConsentsConfirmOrganizationConsent" />
        </div>
        <div class="control">
          <fieldset class="checkbox-inline">
            <Field
              id="HasGivenConsentToInformationCollection"
              v-model="studyInsuranceSubmitTemplate.HasGivenConsentToInformationCollection"
              :rules="'required'"
              name="HasGivenConsentToInformationCollection"
              type="checkbox"
              :value="true"
              :unchecked-value="false"
            />
            <label
              for="HasGivenConsentToInformationCollection"
              class="large"
              v-html="
                modelValue.Content.StepFive.LabelConsentsCosentToInformationCollectionCheckbox
              "
            />
          </fieldset>
          <ValidationError
            name="HasGivenConsentToInformationCollection"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
          />
          <p
            v-html="modelValue.Content.StepFive.LabelConsentsCosentToInformationCollectionConsent"
          />
        </div>
        <div class="control">
          <fieldset class="checkbox-inline">
            <Field
              id="HasGivenConsentToInsuranceAndClaimHistoryCollection"
              v-model="
                studyInsuranceSubmitTemplate.HasGivenConsentToInsuranceAndClaimHistoryCollection
              "
              :rules="'required'"
              name="HasGivenConsentToInsuranceAndClaimHistoryCollection"
              type="checkbox"
              :value="true"
              :unchecked-value="false"
            />
            <label
              for="HasGivenConsentToInsuranceAndClaimHistoryCollection"
              class="large"
              v-html="
                modelValue.Content.StepFive
                  .LabelConsentInsuranceAndClaimHistoryCollectionConsentCheckbox
              "
            />
          </fieldset>
          <ValidationError
            name="HasGivenConsentToInsuranceAndClaimHistoryCollection"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
          />
          <p
            v-html="
              modelValue.Content.StepFive
                .LabelConsentsInsuranceAndClaimHistoryCollectionConsentConsent
            "
          />
        </div>
      </article>
    </section>
    <transition v-cloak name="modal">
      <v-modal :is-open="showNoToCPRConsentModal" @close="CloseCprModal">
        <template #title>
          <div>
            <h2 v-html="modelValue.Content.StepFive.ModalCprConsentHeadline" />
          </div>
        </template>

        <template #content>
          <div>
            <h3 v-html="modelValue.Content.StepFive.ModalCprConsentHeading" />
            <div v-html="modelValue.Content.StepFive.ModalCprConsentDescription" />
          </div>
        </template>
        <template #footer>
          <div>
            <button
              class="button large"
              @click="CloseCprModal"
              v-html="modelValue.Content.StepFive.ModalCprConsentButtonLabel"
            />
          </div>
        </template>
      </v-modal>
    </transition>
  </div>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';

import StudyMixin from './StudyMixin.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';
import CprNumberField from '@/components/UI/CprNumberField.vue';

import { FormContextKey } from 'vee-validate';
import { inject } from 'vue';

export default {
  name: 'PaymentInfoStudy',
  components: {
    CprNumberField,
    H3AndTooltip
  },
  mixins: [StudyMixin],
  emits: ['update:modelValue'],
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  props: {
    modelValue: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      searching: false,
      chosenAnswers: [],
      questions: this.modelValue.Data.Questionnaires,
      content: {},
      noToCPRConsent: false,
      showNoToCPRConsentModal: false
    };
  },
  computed: {
    studyInsuranceSubmitTemplate: {
      get() {
        if (Object.prototype.hasOwnProperty.call(this.modelValue, 'Data')) {
          return this.modelValue.Data.StudyInsuranceSubmitTemplate;
        }
        return {};
      },
      set(val) {
        const tmp = { ...this.modelValue };
        tmp.Data.StudyInsuranceSubmitTemplate = val;
        this.$emit('update:modelValue', tmp);
      }
    },
    paymentFrequensyList() {
      return [
        {
          label: this.modelValue.Content.StepFive.LabelPaymentIntervalYearly
        },
        {
          label: this.modelValue.Content.StepFive.LabelPaymentIntervalQuarterly
        },
        {
          label: this.modelValue.Content.StepFive.LabelPaymentIntervalMonthly
        }
      ];
    },
    showInformationCollectionConsent() {
      return (
        this.studyInsuranceSubmitTemplate.Content_HasInsuranceToTerminate === 1 ||
        this.studyInsuranceSubmitTemplate.Accident_HasInsuranceToTerminate === 1
      );
    }
  },
  watch: {
    'studyInsuranceSubmitTemplate.HasGivenCprConsent': function (val) {
      if (val) {
        this.studyInsuranceSubmitTemplate.CprConsentText =
          this.modelValue.Content.StepFive.LabelConsentsCprConsent;
      } else {
        this.studyInsuranceSubmitTemplate.CprConsentText = null;
      }
    },
    'studyInsuranceSubmitTemplate.HasGivenConsentToContactMemberOrganization': function (val) {
      if (val) {
        this.studyInsuranceSubmitTemplate.ConsentToContactMemberOrganizationText =
          this.modelValue.Content.StepFive.LabelConsentsConfirmOrganizationConsent;
      } else {
        this.studyInsuranceSubmitTemplate.ConsentToContactMemberOrganizationText = null;
      }
    },
    'studyInsuranceSubmitTemplate.HasGivenConsentToInformationCollection': function (val) {
      if (val) {
        this.studyInsuranceSubmitTemplate.ConsentToInformationCollectionText =
          this.modelValue.Content.StepFive.LabelConsentsCosentToInformationCollectionConsent;
      } else {
        this.studyInsuranceSubmitTemplate.ConsentToInformationCollectionText = null;
      }
    },
    'studyInsuranceSubmitTemplate.HasGivenConsentToInsuranceAndClaimHistoryCollection': function (
      val
    ) {
      if (val) {
        this.studyInsuranceSubmitTemplate.ConsentToInsuranceAndClaimHistoryCollectionText =
          this.modelValue.Content.StepFive.LabelConsentInsuranceAndClaimHistoryCollectionConsentCheckbox;
      } else {
        this.studyInsuranceSubmitTemplate.ConsentToInsuranceAndClaimHistoryCollectionText = null;
      }
    }
  },
  mounted() {
    this.content = this.modelValue.Content.StepFive.StepFive;
    Utility.pushToTagManager({
      event: 'track-ga-vp',
      virtualPath: '/virtual/studie-prisberegner-04-betaling',
      virtualTitle: 'Virtuel - Beregn pris - Studie - betaling'
    });
  },
  methods: {
    decodeHtml: Utility.decodeHtml,
    answers() {
      this.chosenAnswers = [];
      for (var i = 0; i < this.questions.length; i++) {
        var question = this.questions[i];
        if (question.chosenAnswer === null) {
          continue;
        }

        var chosenAnswer =
          question.chosenAnswer.text !== undefined
            ? question.chosenAnswer.text
            : question.chosenAnswer;
        this.chosenAnswers.push(chosenAnswer);
      }
    },
    updateQuestionnaire() {
      // Build answer list
      this.answers();
      var $elem;

      for (var i = 0; i < this.questions.length; i++) {
        var currentQuestion = this.questions[i];
        var dependencies = currentQuestion.dependenciesList;
        var isDependenciesTrue = [];

        if (dependencies === undefined || dependencies.length === 0) {
          continue;
        }

        for (var j = 0; j < dependencies.length; j++) {
          var currentDependency = dependencies[j];

          // build current dependency list with booleans
          if (this.chosenAnswers.indexOf(currentDependency.constraintAnswerId) > -1) {
            isDependenciesTrue.push(true);
          } else {
            isDependenciesTrue.push(false);
          }
        }
        // Check if any of the dependecies is ture in the dependency list with booleans
        if (isDependenciesTrue.indexOf(true) > -1) {
          currentQuestion.isActivated = true;
          if (!$elem) {
            $elem = $('#question-' + currentQuestion.questionnaireLineVORef.id);
            Utility.scrollToElem($elem, 200);
          }
        } else {
          // Hide the question if the data in the dependent questions change
          currentQuestion.isActivated = false;
          // Remove from the answer list (this is needed for the next questions, due to interdependency) and remove the chosen answer from the model
          var index = this.chosenAnswers.indexOf(currentQuestion.chosenAnswer);
          if (index > -1) {
            this.chosenAnswers.splice(index, 1);
            currentQuestion.chosenAnswer = '';
          }
        }
      }
    },
    cprConsentSelect() {
      if (!this.studyInsuranceSubmitTemplate.HasGivenCprConsent)
        this.showNoToCPRConsentModal = true;
      this.form.validateField('HasGivenCprConsentYes');
    },
    CloseCprModal() {
      this.showNoToCPRConsentModal = false;
    }
  }
};
</script>
